var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { CircleSpinner } from '..';
const ImageLazyAvatar = (_a) => {
    var { loadingText, style = {}, src = '' } = _a, props = __rest(_a, ["loadingText", "style", "src"]);
    const [isLoaded, setIsLoaded] = useState(false);
    const [srcInternal, setSrcInternal] = useState(null);
    const onLoadImage = () => {
        setIsLoaded(true);
    };
    useEffect(() => {
        setSrcInternal(null);
        setIsLoaded(false);
        setTimeout(() => setSrcInternal(src), 1000);
    }, [src]);
    return (React.createElement("div", { style: { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }, key: `${srcInternal}_${isLoaded}` },
        !isLoaded && (React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                alignContent: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '0.5rem'
            } },
            React.createElement(CircleSpinner, null),
            React.createElement("span", { style: { fontSize: 8 } }, "Rendering..."))),
        srcInternal && (React.createElement("img", Object.assign({ src: srcInternal, onLoad: onLoadImage, style: Object.assign({ display: isLoaded ? 'inherit' : 'none' }, style) }, props)))));
};
export default ImageLazyAvatar;
